"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// From https://github.com/acdlite/recompose/blob/master/src/packages/recompose/utils/mapValues.js
exports.default = (function (obj, func) {
    var result = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = func(obj[key], key);
        }
    }
    return result;
});
//# sourceMappingURL=mapValues.js.map